import { TemplateValue } from "./TemplateValue.js";

/**
 * Find the given variable value in the array of template variable values.
 */
export const findVariableValue = (name: string, values: TemplateValue[]) => {
  const index = values.findIndex((value) => value.name === name);
  if (index < 0) {
    throw new Error(`Cannot find variable ${name}.`);
  }
  return values[index].value;
};
